import UIBox from 'UIComponents/layout/UIBox';
import UIFlex from 'UIComponents/layout/UIFlex';
import { CardsSection } from '../../cardsSection';
import { useMemo, useState } from 'react';
import SectionHeading from '../../../components/SectionHeading';
import FormattedMessage from 'I18n/components/FormattedMessage';
import styled, { css } from 'styled-components';
import { academyPageFullWidth, mediaQuery, theme, useMediaQuery } from 'academy-common-lib/utils/Styling';
import UIRouterButton from 'ui-addon-react-router-dom/UIRouterButton';
import { RESULTS_URL_FRAGMENT } from '../../../constants/Navigation';
import { FILTER_TYPES } from '../../../constants/TopFilterConstants';
import ContentCardSkeleton from '../../../components/TrackCard/ContentCardSkeleton';
import { HasGate } from '../../accounts';
import UsageTracker from '../../../utils/UsageTracker';
import { useShortsBannerData } from '..';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const BannerWrapper = styled.div.withConfig({
  displayName: "ShortsBanner__BannerWrapper",
  componentId: "sc-1mo8vrv-0"
})(["color:", ";background-image:linear-gradient(to right,#225882,#3f8fa2);"], theme.colors.OLAF);
const BannerContent = styled(UIFlex).withConfig({
  displayName: "ShortsBanner__BannerContent",
  componentId: "sc-1mo8vrv-1"
})(["", " padding:44px 48px 0 48px;", ""], academyPageFullWidth, mediaQuery('mobile', css(["padding:20px 12px;h4{font-weight:600;}"])));
const BannerCardContainer = styled.div.withConfig({
  displayName: "ShortsBanner__BannerCardContainer",
  componentId: "sc-1mo8vrv-2"
})(["max-width:400px;width:100%;margin-left:52px;margin-right:52px;.card-skeleton{max-height:260px;overflow:hidden;margin-bottom:28px;}", ""], mediaQuery('mobile', css(["margin-left:0;margin-right:0;margin-top:16px;.card-section{padding-left:0;padding-right:0;padding-bottom:0;h4{font-size:14px;}}"])));
const ShortBannerAction = () => {
  const handleActionClick = () => {
    UsageTracker.track('interaction', {
      action: 'short-banner-see-all'
    });
  };
  return /*#__PURE__*/_jsx(UIRouterButton, {
    onClick: handleActionClick,
    to: `${RESULTS_URL_FRAGMENT}?${FILTER_TYPES.CONTENT_TYPE}=SHORT_FORM_CONTENT`,
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "learningCenter.shortContent.bannerAction"
    })
  });
};
export const ShortsBanner = () => {
  const {
    isMobile
  } = useMediaQuery();
  const [shortIndex, setShortIndex] = useState(0);
  const {
    shortsBannerData,
    shortsBannerDataLoading,
    shortsBannerDataError
  } = useShortsBannerData();
  const allShorts = useMemo(() => shortsBannerData === null || shortsBannerData === void 0 ? void 0 : shortsBannerData.map(({
    id,
    data: {
      language
    }
  }) => ({
    id,
    type: 'SHORT_FORM_CONTENT',
    language: language
  })), [shortsBannerData]);
  const displayedShort = allShorts !== null && allShorts !== void 0 && allShorts.length ? allShorts[shortIndex] : null;
  const handleLoadNextShort = () => setShortIndex(currentIndex => currentIndex + 1);
  const handleLoadPreviousShort = () => setShortIndex(currentIndex => currentIndex - 1);
  if (!shortsBannerDataLoading && !displayedShort) return null;
  return /*#__PURE__*/_jsx(HasGate, {
    gate: "Academy:ShortFormContent",
    children: /*#__PURE__*/_jsx(BannerWrapper, {
      children: /*#__PURE__*/_jsxs(BannerContent, {
        direction: isMobile ? 'column' : 'row',
        children: [/*#__PURE__*/_jsx(UIBox, {
          basis: 0,
          grow: 1,
          children: /*#__PURE__*/_jsxs(UIFlex, {
            direction: "column",
            gap: isMobile ? 12 : 24,
            children: [/*#__PURE__*/_jsx(SectionHeading, {
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "learningCenter.shortContent.bannerTitle"
              })
            }), /*#__PURE__*/_jsxs(UIFlex, {
              direction: "column",
              gap: 8,
              children: [/*#__PURE__*/_jsx(FormattedMessage, {
                message: "learningCenter.shortContent.bannerBody1"
              }), /*#__PURE__*/_jsx(FormattedMessage, {
                message: "learningCenter.shortContent.bannerBody2"
              })]
            }), !isMobile && /*#__PURE__*/_jsx(ShortBannerAction, {})]
          })
        }), /*#__PURE__*/_jsx(UIBox, {
          basis: 0,
          grow: 1,
          style: {
            justifyContent: 'right',
            display: 'flex'
          },
          children: /*#__PURE__*/_jsx(BannerCardContainer, {
            children: displayedShort ? /*#__PURE__*/_jsx(CardsSection, {
              appearsIn: 'shorts-banner',
              content: [displayedShort],
              error: shortsBannerDataError,
              errorMarker: "HOMEPAGE_API_ERROR",
              isLoading: shortsBannerDataLoading,
              navMarker: "HOMEPAGE_SHORTS_BANNER_LOADED",
              onClickNext: handleLoadNextShort,
              onClickPrevious: handleLoadPreviousShort,
              showDescription: false,
              showNext: shortIndex < allShorts.length - 1,
              showOverview: true,
              showPrevious: shortIndex > 0,
              use: "on-blue"
            }) : /*#__PURE__*/_jsx(ContentCardSkeleton, {
              use: "on-blue"
            })
          })
        }), isMobile && /*#__PURE__*/_jsx(ShortBannerAction, {})]
      })
    })
  });
};
export default ShortsBanner;